import { useMutation } from '@tanstack/react-query';
import { post } from '../../shared/api/apiService';
import { useApiEssentials } from '../../shared/hooks/useApiEssentials';

export const sendCredentials = async (
  apiUrl: string,
  idToken: string,
  userID: string,
  email: string,
) => {
  return post(
    `/client_credentials/${userID}/email`,
    { email: email },
    apiUrl,
    idToken,
  );
};

export const useSendCredentials = (userID?: string, email?: string) => {
  const { apiUrl, getIdToken } = useApiEssentials();

  return useMutation({
    mutationFn: async () => {
      const idToken = await getIdToken();
      if (!apiUrl) {
        throw new Error('No API URL is available');
      }
      if (!userID) {
        throw new Error('No user ID is available');
      }
      if (!email) {
        throw new Error('No email is available');
      }
      return sendCredentials(apiUrl, idToken, userID, email);
    },
  });
};
